import React from 'react'

export interface V3ShellLayoutContextValue {
  leftNavWidth: number;
}

const defaultValue: V3ShellLayoutContextValue = {
  leftNavWidth: 0,
}

const V3ShellLayoutContext = React.createContext<V3ShellLayoutContextValue>(defaultValue)

export function V3ShellLayoutProvider({
  value,
  children,
}: {
  value: V3ShellLayoutContextValue;
  children: React.ReactNode;
}) {
  return (
    <V3ShellLayoutContext.Provider value={value}>
      {children}
    </V3ShellLayoutContext.Provider>
  )
}

export function useV3ShellLayout() {
  return React.useContext(V3ShellLayoutContext)
}

